import * as Yup from "yup";

export const dataModel = {
  createdAt: "",
  dateInit: "",
  dateEnd: "",
};

export const validationDataModel = Yup.object().shape({
  createdAt: Yup.date().optional("forms.validations.required"),
  dateInit: Yup.date().optional("forms.validations.required"),
  dateEnd: Yup.date().optional("forms.validations.required"),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
